<template>
    <Teleport to="body">
        <div class="qc-platform-ui">
            <div :class="'qc-playform-modal qc-role-selector-modal ' + (props.className || '')" v-show="props.show">
                <div class="qc-modal-warp">
                    <div class="qc-playform-overlay"></div>
                    <div class="qc-playform-layout">
                        <Header closeBtnIcon="close_btn" :closeHandle="props.onClose" />

                        <div class="qc-playform-content qc-role-selector-content">
                            <div class="qc-tab" v-if="showHdeader">
                                <div 
                                    v-for="(item, index) in headerList" 
                                    :key="index"
                                    :class="{ active: index === activeHeaderIndex }"
                                >
                                    <span @click="handleHeaderClick(index)">{{ item.title }}</span>
                                </div>
                                <div class="qc-playform-skeleton" v-if="dataScoure.length === 0">
                                    <span class="skeleton-rectangle"></span>
                                    <span class="skeleton-rectangle"></span>
                                </div>
                            </div>
                            <div class="qc-role-list">
                                <ul>
                                    <li 
                                        v-for="(item, index) in roleList" 
                                        :key="item.role_id"
                                        :class="{ 
                                            active: props.currentRoleId === item.role_id,
                                            'qc-role-selectd': index === activeRoleIndex 
                                        }"
                                        @click="handleRoleClick(index)"
                                    >
                                        <template v-if="props.render">
                                            <div v-html="props.render(item)"></div>
                                        </template>
                                        <template v-else>
                                            <div class="qc-role-info">
                                                <div class="qc-role-name">
                                                    <div :class="'name-text name-text-' + ((item.last_recharge || 0) + (item.last_login || 0))">{{ item.role_name }}</div>
                                                    <span class="tips tips-1" v-if="item.last_recharge">{{ language[LANGUAGE_KEY.LAST_RECHARGE] }}</span>
                                                    <!-- <span class="tips tips-2" v-if="item.last_login">{{ language[LANGUAGE_KEY.LAST_LOGIN] }}</span> -->
                                                </div>
                                                <div class="qc-role-desc" v-if="item.field_one">{{ item.field_one }}</div>
                                                <div class="qc-role-desc" v-if="item.field_two">{{ item.field_two }}</div>
                                            </div>
                                            <div class="qc-role-operation">
                                                <b :class="index === activeRoleIndex ? 'qc-sprites qc-sprites-selected_icon' : ''"></b>
                                            </div>
                                        </template>
                                    </li>
                                    <li class="qc-playform-skeleton" v-if="dataScoure.length === 0">
                                        <div class="qc-role-info">
                                            <div class="qc-role-name">    
                                                <span class="skeleton-rectangle"></span>      
                                            </div>
                                            <div class="qc-role-desc">
                                                <span class="skeleton-rectangle"></span>
                                            </div>
                                            <div class="qc-role-desc">
                                                <span class="skeleton-rectangle"></span>
                                            </div>
                                        </div>
                                        <div class="qc-role-operation">
                                            <span class="skeleton-circle"></span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="qc-role-selector-confirm">
                                <div class="qc-default-btn qc-confirm-btn" @click="onConfirm()">{{ language[LANGUAGE_KEY.CONFIRM] }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>
<script lang="ts" setup>
import { ref, watch, nextTick, toRaw } from 'vue';
import { Toast } from '../subComponents/Toast/index';
import Header from '../subComponents/Header/index.vue';
import ApiManager from '../core/api/index';
import configManager from '../core/config/index';
import { LANGUAGE_KEY } from '../core/constants/language'
import type { RoleItem, RoleInfo, RoleTabItem, RoleSelectorProps } from './types';

const props = withDefaults(defineProps<RoleSelectorProps>(), {
    show: false,
    className: ''
});

const dataScoure = ref<RoleInfo[]>([]);
const showHdeader = ref(true);
const headerList = ref<RoleTabItem[]>([]);
const roleList = ref<RoleItem[]>([]);

// 直接使用响应式配置，无需 ref 包装
const language = configManager.getLanguage();

// 当前激活的头部索引
const activeHeaderIndex = ref(0);
// 选中节点的索引
const activeRoleIndex = ref(-1);

/**
 * 角色列表滚动到顶部
 */
 const scrollToTop = () => {
    const roleListElement = document.querySelector('.qc-role-list ul');
    if (roleListElement) {
        roleListElement.scrollTop = 0;
    }
};
/**
 * 处理头部点击事件
 * @param index 点击的索引
 */
const handleHeaderClick = (index: number) => {
    if (activeHeaderIndex.value === index) {
        return;
    }
    activeHeaderIndex.value = index;
    
    const selectedRoleList = dataScoure.value[index].role_list;
    roleList.value = selectedRoleList;
    const currentRoleIndex = selectedRoleList.findIndex(role => role.role_id === props.currentRoleId);
    if (currentRoleIndex !== -1) {
        activeRoleIndex.value = currentRoleIndex;
    } else {
        activeRoleIndex.value = -1;
    }
    nextTick(() => { scrollToTop(); });
};
const handleRoleClick = (index: number) => {
    if (activeRoleIndex.value === index) {
        return;
    }
    activeRoleIndex.value = index;
}
const onConfirm = () => {
    if (activeRoleIndex.value === -1) {
        return;
    }
    // 使用 toRaw 获取原始数据，避免返回 Proxy 对象
    const rawData = toRaw(roleList.value[activeRoleIndex.value]);
    props.onConfirm({
        game: {
            ...headerList.value[activeHeaderIndex.value]
        },
        ...rawData
    });
};

// 高亮角色行
const autoHighlightRoleItem = () => {
    dataScoure.value.map((gameData, gameIdx) => {
        const index = gameData.role_list.findIndex((role) => {
            return role.role_id === props.currentRoleId;
        });
        if (index !== -1) {
            activeHeaderIndex.value = gameIdx;
            activeRoleIndex.value = index;
            roleList.value = gameData.role_list;
        }
    });
};

watch(() => props.show, async () => {
    if (props.show) {
        const { token, displayLastLogin, displayLastRecharge, parentGameId, allowedGameIds } = props.params;
        ApiManager.getInstance().user
            .getRoleInfo({
                token,
                isLastLogin: displayLastLogin ? 1 : 0,
                isLastRecharge: displayLastRecharge ? 1 : 0,
                game_id: allowedGameIds,
                parentGameId
            }).then((response) => {
                if (response.code === 200) {
                    const data = response.metadata.data;
                    dataScoure.value = data;
                    headerList.value = data.map((item: any) => {
                        const { title, game_id, status } = item;
                        return { title, game_id, status };
                    });
                    if (headerList.value.length === 1 && headerList.value[0].title === "") {
                        showHdeader.value = false;
                    } else {
                        showHdeader.value = true;
                    }
                    roleList.value = data[0].role_list;
                    autoHighlightRoleItem();
                } else {
                    Toast(response.message);
                    props.onError(response);
                }
            });
        
    } else {
        dataScoure.value = [];
        headerList.value = [];
        roleList.value = [];
        activeHeaderIndex.value = 0;
        activeRoleIndex.value = -1;
        showHdeader.value = true;
    }
});



</script>
<style lang="less" scoped>
@import url('./style/index.less');
</style>